var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashcanXIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.97 94.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "49.91 6.65 49.91 0 21.06 0 21.06 6.65 0 6.65 0 16.14 70.97 16.14 70.97 6.65 49.91 6.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.89,86.54c0,4.23,3.43,7.67,7.67,7.67h47.86c4.23,0,7.67-3.43,7.67-7.67V20.35H3.89v66.19Zm13.09-35.72l6.98-6.7,11.66,12.16,12.16-11.67,6.7,6.98-12.16,11.67,11.66,12.16-6.98,6.7-11.66-12.16-12.15,11.66-6.7-6.98,12.15-11.66-11.66-12.16Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcanXIcon);
export default __webpack_public_path__ + "static/media/TrashcanXIcon.9c3a65c1257a0b07bdbb74f7d86f8936.svg";
export { ForwardRef as ReactComponent };